import { useEffect, useState } from "react";
import query from "../../../../server/constants.api";
import useFetch from "../../../../server/useFetch";
import Spinner from '../../Atomics/Spinner';
import { NewMap } from '@synergy/maps';
import styled from "styled-components";
import { Flex } from "antd";

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const ErrorMessage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 16px;
    color: black;
    font-weight: bold;
`;

const MapWrapper = styled.div`
    height: ${props => (props.$marginTop ? 'calc(100% - ' + props.$marginTop + ')' : props.$height)};
    margin-top: ${props => (props.$marginTop ? props.$marginTop : '0')};
    padding: 0;
    width: -webkit-fill-available;
`;

const test = [
    {
        "id": "1fd56ede-9140-47ec-8db9-8b129aaf693d",
        "name": "VGVsZWZvbmUgZGEgcmVjZcOnw6NvIGF2YXJpYWRv",
        "label": "Incident",
        "address": null,
        "latitude": "41.15504",
        "longitude": "-8.63016",
        "numberOfFloors": null,
        "subtype": null,
        "capacity": null,
        "tenant": "TOP/DELOITTE/PT/PORTO/BOM SUCESSO",
        "active": "1",
        "location": null,
        "family": "Buildings.Commercial",
        "status": "Registered",
        "priority": "5 - Low",
        "urgency": "5 - When Possible",
        "class": "Office"
    },
    {
        "id": "0d7c0e23-2505-4de1-9f67-c3bac448947b",
        "name": "UG9ydGEgZGUgZW50cmFkYSBkYW5pZmljYWRh",
        "label": "Incident",
        "address": null,
        "latitude": "41.15504",
        "longitude": "-8.63016",
        "numberOfFloors": null,
        "subtype": null,
        "capacity": null,
        "tenant": "TOP/DELOITTE/PT/PORTO/BOM SUCESSO",
        "active": "1",
        "location": null,
        "family": "Buildings.Commercial",
        "status": "Registered",
        "priority": "5 - Low",
        "urgency": "5 - When Possible",
        "class": "Office"
    },
    {
        "id": "077f3265-54ff-4987-9fda-f7763d2095b3",
        "name": "RWxldmFkb3IgYXZhcmlhZG8=",
        "label": "Incident",
        "address": null,
        "latitude": "41.15795",
        "longitude": "-8.64297",
        "numberOfFloors": null,
        "subtype": null,
        "capacity": null,
        "tenant": "TOP/DELOITTE/PT/PORTO/BESSA LEITE",
        "active": "1",
        "location": null,
        "family": "Buildings.Commercial",
        "status": "Registered",
        "priority": "5 - Low",
        "urgency": "5 - When Possible",
        "class": "Office"
    }
]
//#endregion

// Define the SimpleMapComponent function component
export const SimpleMapComponent = ({ pois, height }) => {
    const [mapData, setMapData] = useState(null);

    // Fetch map configurations and map data using custom hooks
    const { data: mapConfigurationsData, isLoading: mapConfigurationsDataIsLoading, refetch: refetchMapConfigurationsData } = useFetch(query.path.mapConfiguration, 'mapRegisterConfigurations');

    // useEffect(()=> {
    //     if(mapConfigurationsData){
    //         setMapData({
    //             configurations: mapConfigurationsData,
    //             pois: item ?? null,
    //             center: idCenter ?? null,
    //             zoom: idZoom ?? null,
    //             mapId: mapId ?? null
    //         })
    //     }
    // }, [mapConfigurationsData])

    // Render SimpleMapComponent
    return (
        <MapWrapper $height={height}>
            {!mapConfigurationsDataIsLoading ? (
                // !isNaN(idCenter?.lat) && !isNaN(idCenter?.lng) ? (
                    <NewMap configurations={mapConfigurationsData} pois={test} />
                    // <MapApp data={mapData} disableClick={disableClick} />
                // ) : (
                //     <ErrorMessage>Posição do POI inválida</ErrorMessage>
                // )
            ) : (
                <Flex align="center" justify="center" className="full-h">
                    <Spinner stroke="green-4" />
                </Flex>
            )}
        </MapWrapper>
    );
}